import { Breakpoints } from "../theme.types";

const breakpoints: Breakpoints = {
    xs: '576px',
    sm: '768px',
    md: '1024px',
    lg: '1366px',
    xl: '1920px',
    xxl: '2560px',
};

export default breakpoints;
